import * as React from 'react';

export const ClientInfo: React.FC<{}> = ({}) => {
    return <div>Place to display client info</div>;
};

export default ClientInfo;
